
import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { AdvisorySessionForm } from '@/components/advisory/AdvisorySessionForm';

const AdvisoryCta = () => {
  const { toast } = useToast();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleWebhookSubmit = async (formData: Record<string, any>) => {
    try {
      const webhookUrl = "https://hook.us2.make.com/f9waudrud3pvymdixk0frbpq9t90bdna";
      
      await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "no-cors",
        body: JSON.stringify({
          ...formData,
          source: "Advisory CTA Form",
          timestamp: new Date().toISOString(),
          page: window.location.href
        }),
      });

      toast({
        title: "Thank you!",
        description: "Your request has been submitted. We'll contact you shortly.",
      });
      
      setIsDialogOpen(false);
    } catch (error) {
      console.error("Error triggering webhook:", error);
      toast({
        title: "Submission failed",
        description: "There was an issue processing your request. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Your Next Best Step: A Free Advisory Session
          </h2>
          <p className="text-lg text-white/80 mb-3">
            Real strategic advice — not just a sales conversation.
          </p>
          <p className="text-white/80 mb-8">
            We'll work together to understand your goals, identify risks, spot opportunities, and recommend actionable next steps you can take immediately. Whether or not you continue with DocketLabs after the call, you'll leave with valuable insights tailored to your firm.
          </p>
          <Button 
            size="lg" 
            className="text-white bg-blue-600 hover:bg-blue-700 font-medium text-lg"
            onClick={() => setIsDialogOpen(true)}
          >
            Book My Free Advisory Session
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <p className="mt-4 text-white/60 text-sm">
            Get your free expert help. We'll figure out what fits after you get some value.
          </p>
        </div>
      </div>

      {/* Advisory Session Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Book Your Free Advisory Session</DialogTitle>
            <DialogDescription>
              Fill out the form below to schedule your complimentary advisory session with our legal AI experts.
            </DialogDescription>
          </DialogHeader>
          <AdvisorySessionForm onSubmit={handleWebhookSubmit} />
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default AdvisoryCta;
